// Тема «как в телефоне»: светлая или тёмная — по Telegram, иначе по настройке системы.
//
// Это внешнее хранилище, которое меняется само (человек переключил тему Telegram или телефона),
// поэтому React подписывается на него через useSyncExternalStore — без счётчика-«пинка», который
// раньше заставлял пересчитывать тему (App.tsx до 30 сен 2026).

import { useSyncExternalStore } from 'react';

export type ColorScheme = 'light' | 'dark';

interface TelegramThemeApi {
  colorScheme?: string;
  onEvent?: (event: string, cb: () => void) => void;
  offEvent?: (event: string, cb: () => void) => void;
}

function telegram(): TelegramThemeApi | undefined {
  return (window as unknown as { Telegram?: { WebApp?: TelegramThemeApi } }).Telegram?.WebApp;
}

export function readSystemColorScheme(): ColorScheme {
  const tg = telegram()?.colorScheme;
  if (tg === 'light' || tg === 'dark') return tg;
  if (window.matchMedia?.('(prefers-color-scheme: light)').matches) return 'light';
  return 'dark';
}

function subscribe(onChange: () => void): () => void {
  telegram()?.onEvent?.('themeChanged', onChange);
  const mq = window.matchMedia?.('(prefers-color-scheme: light)');
  mq?.addEventListener?.('change', onChange);
  return () => {
    telegram()?.offEvent?.('themeChanged', onChange);
    mq?.removeEventListener?.('change', onChange);
  };
}

export function useSystemColorScheme(): ColorScheme {
  return useSyncExternalStore(subscribe, readSystemColorScheme, () => 'dark');
}
